var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('edit-building',{attrs:{"data-test-id":"edit-building","project-id":_vm.projectId,"building-id":_vm.buildingId,"title":_vm.$t('registerProjectTitle'),"submit-text":"submitProject","handle-submit":_vm.submitRegistration}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }